"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVATAR_LIST = void 0;
exports.AVATAR_LIST = {
    beastman: [
        { file: "72a0f531-68c7-46a4-af59-078ecaf891fb-0_0.jpeg", rarity: "c" },
        { file: "72a0f531-68c7-46a4-af59-078ecaf891fb-0_1.jpeg", rarity: "c" },
        { file: "72a0f531-68c7-46a4-af59-078ecaf891fb-0_2.jpeg", rarity: "c" },
        { file: "72a0f531-68c7-46a4-af59-078ecaf891fb-0_3.jpeg", rarity: "c" },
        { file: "c5f43368-72bf-4a45-8ecb-fe5a2e3d0eb9-0_0.jpeg", rarity: "c" },
        { file: "c5f43368-72bf-4a45-8ecb-fe5a2e3d0eb9-0_1.jpeg", rarity: "c" },
        { file: "c5f43368-72bf-4a45-8ecb-fe5a2e3d0eb9-0_2.jpeg", rarity: "c" },
        { file: "c5f43368-72bf-4a45-8ecb-fe5a2e3d0eb9-0_3.jpeg", rarity: "c" },
    ],
    "black-orc": [
        { file: "305182b7-cfab-4aff-aad5-e6633d3ba89a-0_0.jpeg", rarity: "c" },
        { file: "59304479-00ae-4262-ba95-171dbaaf730a-0_2.jpeg", rarity: "c" },
        { file: "8c27613f-c137-4d54-b9fe-a3b0bfc72a59-0_1.jpeg", rarity: "c" },
        { file: "8c27613f-c137-4d54-b9fe-a3b0bfc72a59-0_2.jpeg", rarity: "c" },
        { file: "8c27613f-c137-4d54-b9fe-a3b0bfc72a59-0_3.jpeg", rarity: "c" },
        { file: "9e05b2b0-1d3c-48d5-a779-5e1b715b9783-0_0.jpeg", rarity: "c" },
        { file: "9e05b2b0-1d3c-48d5-a779-5e1b715b9783-0_1.jpeg", rarity: "c" },
        { file: "9e05b2b0-1d3c-48d5-a779-5e1b715b9783-0_2.jpeg", rarity: "c" },
        { file: "a88f6511-ea9e-4901-b85d-d8b760a5e0a2-0_1.jpeg", rarity: "c" },
        { file: "a88f6511-ea9e-4901-b85d-d8b760a5e0a2-0_2.jpeg", rarity: "c" },
        { file: "a88f6511-ea9e-4901-b85d-d8b760a5e0a2-0_3.jpeg", rarity: "c" },
        { file: "e1220979-43a5-4c97-80b3-85a4a6dd7830-0_3.jpeg", rarity: "c" },
        { file: "e9d48abc-c31f-4df2-a59a-d4c94e97c268-0_0.jpeg", rarity: "c" },
        { file: "e9d48abc-c31f-4df2-a59a-d4c94e97c268-0_1.jpeg", rarity: "c" },
        { file: "e9d48abc-c31f-4df2-a59a-d4c94e97c268-0_2.jpeg", rarity: "c" },
        { file: "ed526104-8494-431c-9235-5c04c473a1cf-0_1.jpeg", rarity: "c" },
        { file: "f4931ac0-ffde-483d-879b-e633cefb9fab-0_0.jpeg", rarity: "c" },
        { file: "f4931ac0-ffde-483d-879b-e633cefb9fab-0_1.jpeg", rarity: "c" },
        { file: "fe7cc1dc-e185-47ac-82a4-f892d7b62620-0_1.jpeg", rarity: "c" },
        { file: "fe7cc1dc-e185-47ac-82a4-f892d7b62620-0_2.jpeg", rarity: "c" },
        { file: "fe7cc1dc-e185-47ac-82a4-f892d7b62620-0_3.jpeg", rarity: "c" },
    ],
    bloater: [
        { file: "09fe73e8-f46b-4a10-ab63-db96d8f21e44-0_2.jpeg", rarity: "c" },
        { file: "09fe73e8-f46b-4a10-ab63-db96d8f21e44-0_3.jpeg", rarity: "c" },
        { file: "316535f2-0a59-4b82-92dc-37b5377a0f34-0_2.jpeg", rarity: "c" },
        { file: "60fd15a1-72c1-4b51-b510-0db8b678b567-0_0.jpeg", rarity: "c" },
        { file: "60fd15a1-72c1-4b51-b510-0db8b678b567-0_1.jpeg", rarity: "c" },
        { file: "60fd15a1-72c1-4b51-b510-0db8b678b567-0_2.jpeg", rarity: "c" },
        { file: "f3615f42-f24f-4427-a3fd-0c4e95847bb4-0_0.jpeg", rarity: "c" },
        { file: "f3615f42-f24f-4427-a3fd-0c4e95847bb4-0_1.jpeg", rarity: "c" },
    ],
    bloodspawn: [
        { file: "ead6d8ee-75e8-4008-80bd-8d0508b0907d-0_2.jpeg", rarity: "c" },
        { file: "ead6d8ee-75e8-4008-80bd-8d0508b0907d-0_3.jpeg", rarity: "c" },
    ],
    centaur: [
        { file: "90d0b695-6ff9-4d35-b94f-456674f73b59-0_3.jpeg", rarity: "c" },
        { file: "fc036651-f494-4a0c-a0ef-30e6ae2ebbad-0_0.jpeg", rarity: "c" },
        { file: "fc036651-f494-4a0c-a0ef-30e6ae2ebbad-0_2.jpeg", rarity: "c" },
        { file: "fc036651-f494-4a0c-a0ef-30e6ae2ebbad-0_3.jpeg", rarity: "c" },
    ],
    "chaos-dwarf": [
        { file: "1ea203cd-ca1c-4bb7-b76d-9881cfd4c77c-0_3.jpeg", rarity: "c" },
        { file: "2372f57e-b9a9-419e-80dd-bab2afbd140d-0_0.jpeg", rarity: "c" },
        { file: "2372f57e-b9a9-419e-80dd-bab2afbd140d-0_1.jpeg", rarity: "c" },
        { file: "2372f57e-b9a9-419e-80dd-bab2afbd140d-0_2.jpeg", rarity: "c" },
        { file: "2372f57e-b9a9-419e-80dd-bab2afbd140d-0_3.jpeg", rarity: "c" },
        { file: "90d0b695-6ff9-4d35-b94f-456674f73b59-0_0.jpeg", rarity: "c" },
        { file: "90d0b695-6ff9-4d35-b94f-456674f73b59-0_1.jpeg", rarity: "c" },
        { file: "90d0b695-6ff9-4d35-b94f-456674f73b59-0_2.jpeg", rarity: "c" },
        { file: "9aa71e43-fdef-4357-b8a1-b1cd84dab057-0_0.jpeg", rarity: "c" },
        { file: "9aa71e43-fdef-4357-b8a1-b1cd84dab057-0_1.jpeg", rarity: "c" },
        { file: "9aa71e43-fdef-4357-b8a1-b1cd84dab057-0_2.jpeg", rarity: "c" },
        { file: "9aa71e43-fdef-4357-b8a1-b1cd84dab057-0_3.jpeg", rarity: "c" },
        { file: "9f6c18f7-31c9-4b25-8af0-7e679d23f3bf-0_0.jpeg", rarity: "c" },
        { file: "9f6c18f7-31c9-4b25-8af0-7e679d23f3bf-0_1.jpeg", rarity: "c" },
        { file: "9f6c18f7-31c9-4b25-8af0-7e679d23f3bf-0_2.jpeg", rarity: "c" },
        { file: "9f6c18f7-31c9-4b25-8af0-7e679d23f3bf-0_3.jpeg", rarity: "c" },
        { file: "a336d211-9b5f-4335-a3cc-573778f7bcff-0_0.jpeg", rarity: "c" },
        { file: "a336d211-9b5f-4335-a3cc-573778f7bcff-0_1.jpeg", rarity: "c" },
        { file: "a336d211-9b5f-4335-a3cc-573778f7bcff-0_2.jpeg", rarity: "c" },
        { file: "a336d211-9b5f-4335-a3cc-573778f7bcff-0_3.jpeg", rarity: "c" },
        { file: "b48e8570-8fe5-4a5b-9b82-5f1076036853-0_0.jpeg", rarity: "c" },
        { file: "b48e8570-8fe5-4a5b-9b82-5f1076036853-0_1.jpeg", rarity: "c" },
        { file: "b48e8570-8fe5-4a5b-9b82-5f1076036853-0_2.jpeg", rarity: "c" },
        { file: "b48e8570-8fe5-4a5b-9b82-5f1076036853-0_3.jpeg", rarity: "c" },
        { file: "b4d53478-3af8-4b3e-87ec-9f8312fbbf75-0_0.jpeg", rarity: "c" },
        { file: "b4d53478-3af8-4b3e-87ec-9f8312fbbf75-0_1.jpeg", rarity: "c" },
        { file: "b4d53478-3af8-4b3e-87ec-9f8312fbbf75-0_2.jpeg", rarity: "c" },
        { file: "b4d53478-3af8-4b3e-87ec-9f8312fbbf75-0_3.jpeg", rarity: "c" },
        { file: "dc015022-6f70-403e-ba87-2e87a28c85f1-0_0.jpeg", rarity: "c" },
        { file: "dc015022-6f70-403e-ba87-2e87a28c85f1-0_1.jpeg", rarity: "c" },
        { file: "dc015022-6f70-403e-ba87-2e87a28c85f1-0_2.jpeg", rarity: "c" },
        { file: "dc015022-6f70-403e-ba87-2e87a28c85f1-0_3.jpeg", rarity: "c" },
    ],
    "chaos-warrior": [
        { file: "06342dab-92be-4ce8-9ec5-d8bec62ce43d-0_0.jpeg", rarity: "c" },
        { file: "06342dab-92be-4ce8-9ec5-d8bec62ce43d-0_1.jpeg", rarity: "c" },
        { file: "06342dab-92be-4ce8-9ec5-d8bec62ce43d-0_2.jpeg", rarity: "c" },
        { file: "0a77aa8f-8b01-451d-9b30-91bb211cfc1b-0_0.jpeg", rarity: "c" },
        { file: "0a77aa8f-8b01-451d-9b30-91bb211cfc1b-0_2.jpeg", rarity: "c" },
        { file: "0bc704b6-1912-4293-aef9-14252e2becfd-0_1.jpeg", rarity: "c" },
        { file: "2862cd86-5e9a-4966-811d-5b6c468f242e-0_0.jpeg", rarity: "c" },
        { file: "2862cd86-5e9a-4966-811d-5b6c468f242e-0_1.jpeg", rarity: "c" },
        { file: "2862cd86-5e9a-4966-811d-5b6c468f242e-0_2.jpeg", rarity: "c" },
        { file: "2862cd86-5e9a-4966-811d-5b6c468f242e-0_3.jpeg", rarity: "c" },
        { file: "305182b7-cfab-4aff-aad5-e6633d3ba89a-0_0.jpeg", rarity: "c" },
        { file: "526a315a-786a-4a5a-b465-1345bc321317-0_0.jpeg", rarity: "c" },
        { file: "526a315a-786a-4a5a-b465-1345bc321317-0_1.jpeg", rarity: "c" },
        { file: "526a315a-786a-4a5a-b465-1345bc321317-0_2.jpeg", rarity: "c" },
        { file: "526a315a-786a-4a5a-b465-1345bc321317-0_3.jpeg", rarity: "c" },
        { file: "5a9b8c5b-ccb9-40b1-8d72-84249205e843-0_0.jpeg", rarity: "c" },
        { file: "5a9b8c5b-ccb9-40b1-8d72-84249205e843-0_2.jpeg", rarity: "c" },
        { file: "5a9b8c5b-ccb9-40b1-8d72-84249205e843-0_3.jpeg", rarity: "c" },
        { file: "5e73432d-c016-4c53-b8b0-b5313f2b6950-0_0.jpeg", rarity: "c" },
        { file: "5e73432d-c016-4c53-b8b0-b5313f2b6950-0_1.jpeg", rarity: "c" },
        { file: "5e73432d-c016-4c53-b8b0-b5313f2b6950-0_2.jpeg", rarity: "c" },
        { file: "5e73432d-c016-4c53-b8b0-b5313f2b6950-0_3.jpeg", rarity: "c" },
        { file: "6059b79e-e01f-4323-a3b1-79d4711dfc96-0_0.jpeg", rarity: "c" },
        { file: "6059b79e-e01f-4323-a3b1-79d4711dfc96-0_2.jpeg", rarity: "c" },
        { file: "6059b79e-e01f-4323-a3b1-79d4711dfc96-0_3.jpeg", rarity: "c" },
        { file: "60fd15a1-72c1-4b51-b510-0db8b678b567-0_1.jpeg", rarity: "c" },
        { file: "60fd15a1-72c1-4b51-b510-0db8b678b567-0_2.jpeg", rarity: "c" },
        { file: "67c716c3-0b01-46f4-af47-c89fe60c7db8-0_2.jpeg", rarity: "c" },
        { file: "67c716c3-0b01-46f4-af47-c89fe60c7db8-0_3.jpeg", rarity: "c" },
        { file: "7ee49ae2-9d06-4235-b00d-c731da4b8f01-0_0.jpeg", rarity: "c" },
        { file: "7ee49ae2-9d06-4235-b00d-c731da4b8f01-0_1.jpeg", rarity: "c" },
        { file: "7ee49ae2-9d06-4235-b00d-c731da4b8f01-0_2.jpeg", rarity: "c" },
        { file: "87876ad9-80ab-4cef-a8c2-c47289113efe-0_0.jpeg", rarity: "c" },
        { file: "c53976da-1160-4f62-a141-88e4ce7a85f7-0_3.jpeg", rarity: "c" },
        { file: "e9d48abc-c31f-4df2-a59a-d4c94e97c268-0_2.jpeg", rarity: "c" },
        { file: "e9d48abc-c31f-4df2-a59a-d4c94e97c268-0_3.jpeg", rarity: "c" },
        { file: "f3615f42-f24f-4427-a3fd-0c4e95847bb4-0_2.jpeg", rarity: "c" },
        { file: "f6854414-ce56-493b-bb11-6bfa04b28fa2-0_0.jpeg", rarity: "c" },
        { file: "f6854414-ce56-493b-bb11-6bfa04b28fa2-0_1.jpeg", rarity: "c" },
        { file: "f6854414-ce56-493b-bb11-6bfa04b28fa2-0_2.jpeg", rarity: "c" },
        { file: "f91ac586-dece-45ee-9e61-d4aa20ec9982-0_0.jpeg", rarity: "c" },
    ],
    dark_elf: [
        { file: "59304479-00ae-4262-ba95-171dbaaf730a-0_0.jpeg", rarity: "c" },
        { file: "59304479-00ae-4262-ba95-171dbaaf730a-0_1.jpeg", rarity: "c" },
        { file: "59304479-00ae-4262-ba95-171dbaaf730a-0_3.jpeg", rarity: "c" },
        { file: "a920dc5e-396b-4dae-8d65-bc523bbdec48-0_1.jpeg", rarity: "c" },
        { file: "a920dc5e-396b-4dae-8d65-bc523bbdec48-0_2.jpeg", rarity: "c" },
        { file: "a920dc5e-396b-4dae-8d65-bc523bbdec48-0_3.jpeg", rarity: "c" },
        { file: "c53976da-1160-4f62-a141-88e4ce7a85f7-0_0.jpeg", rarity: "c" },
        { file: "caf93baf-3fbf-4642-8c3f-c86299919fa5-0_0.jpeg", rarity: "c" },
        { file: "caf93baf-3fbf-4642-8c3f-c86299919fa5-0_1.jpeg", rarity: "c" },
        { file: "caf93baf-3fbf-4642-8c3f-c86299919fa5-0_2.jpeg", rarity: "c" },
        { file: "caf93baf-3fbf-4642-8c3f-c86299919fa5-0_3.jpeg", rarity: "c" },
        { file: "d1fe2509-32b4-4d25-836f-36a08f476ca4-0_0.jpeg", rarity: "c" },
        { file: "d1fe2509-32b4-4d25-836f-36a08f476ca4-0_1.jpeg", rarity: "c" },
        { file: "d1fe2509-32b4-4d25-836f-36a08f476ca4-0_2.jpeg", rarity: "c" },
        { file: "d1fe2509-32b4-4d25-836f-36a08f476ca4-0_3.jpeg", rarity: "c" },
        { file: "e6e3a946-a681-4239-8ed4-1c2e41c69b47-0_0.jpeg", rarity: "c" },
        { file: "e6e3a946-a681-4239-8ed4-1c2e41c69b47-0_1.jpeg", rarity: "c" },
        { file: "e6e3a946-a681-4239-8ed4-1c2e41c69b47-0_2.jpeg", rarity: "c" },
        { file: "e6e3a946-a681-4239-8ed4-1c2e41c69b47-0_3.jpeg", rarity: "c" },
        { file: "fe19f514-14e5-415b-9f9a-2cd506c8f72b-0_0.jpeg", rarity: "c" },
        { file: "fe91a1c7-6129-4200-8019-ee737798902e-0_3.jpeg", rarity: "c" },
    ],
    dwarf: [
        { file: "1ea203cd-ca1c-4bb7-b76d-9881cfd4c77c-0_0.jpeg", rarity: "c" },
        { file: "1ea203cd-ca1c-4bb7-b76d-9881cfd4c77c-0_1.jpeg", rarity: "c" },
        { file: "1ea203cd-ca1c-4bb7-b76d-9881cfd4c77c-0_2.jpeg", rarity: "c" },
        { file: "2285c64a-1f02-4635-92cf-5afaa80dde96-0_0.jpeg", rarity: "c" },
        { file: "2285c64a-1f02-4635-92cf-5afaa80dde96-0_1.jpeg", rarity: "c" },
        { file: "2285c64a-1f02-4635-92cf-5afaa80dde96-0_2.jpeg", rarity: "c" },
        { file: "96169e70-b67a-4453-bb34-a7cbcc1b6b29-0_1.jpeg", rarity: "c" },
        { file: "a53b6a90-17be-427e-9a4f-e85ad4bfcc1b-0_0.jpeg", rarity: "c" },
        { file: "a53b6a90-17be-427e-9a4f-e85ad4bfcc1b-0_1.jpeg", rarity: "c" },
        { file: "a53b6a90-17be-427e-9a4f-e85ad4bfcc1b-0_2.jpeg", rarity: "c" },
        { file: "a53b6a90-17be-427e-9a4f-e85ad4bfcc1b-0_3.jpeg", rarity: "c" },
        { file: "bfd51f61-cfb5-4193-9be3-8bfda6606e51-0_0.jpeg", rarity: "c" },
        { file: "bfd51f61-cfb5-4193-9be3-8bfda6606e51-0_1.jpeg", rarity: "c" },
        { file: "bfd51f61-cfb5-4193-9be3-8bfda6606e51-0_2.jpeg", rarity: "c" },
        { file: "bfd51f61-cfb5-4193-9be3-8bfda6606e51-0_3.jpeg", rarity: "c" },
        { file: "ce4c3650-ef74-42c8-b96d-9c7d7e3a3c89-0_0.jpeg", rarity: "c" },
        { file: "ce4c3650-ef74-42c8-b96d-9c7d7e3a3c89-0_1.jpeg", rarity: "c" },
        { file: "ce4c3650-ef74-42c8-b96d-9c7d7e3a3c89-0_2.jpeg", rarity: "c" },
        { file: "ce4c3650-ef74-42c8-b96d-9c7d7e3a3c89-0_3.jpeg", rarity: "c" },
        { file: "d3214f66-1473-48ba-9f78-206a8d9bfe26-0_0.jpeg", rarity: "c" },
        { file: "d3214f66-1473-48ba-9f78-206a8d9bfe26-0_1.jpeg", rarity: "c" },
        { file: "d3214f66-1473-48ba-9f78-206a8d9bfe26-0_2.jpeg", rarity: "c" },
        { file: "d3214f66-1473-48ba-9f78-206a8d9bfe26-0_3.jpeg", rarity: "c" },
        { file: "d33028ca-296a-4c74-bdde-c456ff59ca22-0_1.jpeg", rarity: "c" },
        { file: "d33028ca-296a-4c74-bdde-c456ff59ca22-0_2.jpeg", rarity: "c" },
        { file: "d33028ca-296a-4c74-bdde-c456ff59ca22-0_3.jpeg", rarity: "c" },
        { file: "d3f7031c-4042-4fce-a5ab-82718596a5d6-0_0.jpeg", rarity: "c" },
        { file: "d3f7031c-4042-4fce-a5ab-82718596a5d6-0_1.jpeg", rarity: "c" },
        { file: "d3f7031c-4042-4fce-a5ab-82718596a5d6-0_2.jpeg", rarity: "c" },
        { file: "d3f7031c-4042-4fce-a5ab-82718596a5d6-0_3.jpeg", rarity: "c" },
        { file: "dfba89be-90ae-4509-bbee-22722e13b8e2-0_3.jpeg", rarity: "c" },
        { file: "f4cba3ef-8ac1-4a8c-9b1f-7c58720ef14c-0_0.jpeg", rarity: "c" },
        { file: "f4cba3ef-8ac1-4a8c-9b1f-7c58720ef14c-0_1.jpeg", rarity: "c" },
        { file: "f4cba3ef-8ac1-4a8c-9b1f-7c58720ef14c-0_3.jpeg", rarity: "c" },
        { file: "f82cc750-852c-4f42-ba51-88136400f89b-0_0.jpeg", rarity: "c" },
        { file: "f82cc750-852c-4f42-ba51-88136400f89b-0_1.jpeg", rarity: "c" },
        { file: "f82cc750-852c-4f42-ba51-88136400f89b-0_2.jpeg", rarity: "c" },
        { file: "f82cc750-852c-4f42-ba51-88136400f89b-0_3.jpeg", rarity: "c" },
        { file: "fb513272-007a-4139-b8dd-eb22e9220504-0_0.jpeg", rarity: "c" },
    ],
    elf: [
        { file: "0a77aa8f-8b01-451d-9b30-91bb211cfc1b-0_3.jpeg", rarity: "c" },
        { file: "0a7b1fff-581a-4a6c-b55c-f838e0d5a4c9-0_0.jpeg", rarity: "c" },
        { file: "0a7b1fff-581a-4a6c-b55c-f838e0d5a4c9-0_1.jpeg", rarity: "c" },
        { file: "0a7b1fff-581a-4a6c-b55c-f838e0d5a4c9-0_2.jpeg", rarity: "c" },
        { file: "0a7b1fff-581a-4a6c-b55c-f838e0d5a4c9-0_3.jpeg", rarity: "c" },
        { file: "0bc704b6-1912-4293-aef9-14252e2becfd-0_2.jpeg", rarity: "c" },
        { file: "0d93a543-0621-49d4-b569-75be58a2a6a5-0_1.jpeg", rarity: "c" },
        { file: "1015f692-090b-467f-8124-18811ac61bf2-0_0.jpeg", rarity: "c" },
        { file: "1015f692-090b-467f-8124-18811ac61bf2-0_1.jpeg", rarity: "c" },
        { file: "2788271d-642c-496a-ae1e-a78b9b3d5106-0_0.jpeg", rarity: "c" },
        { file: "2788271d-642c-496a-ae1e-a78b9b3d5106-0_1.jpeg", rarity: "c" },
        { file: "2788271d-642c-496a-ae1e-a78b9b3d5106-0_2.jpeg", rarity: "c" },
        { file: "2788271d-642c-496a-ae1e-a78b9b3d5106-0_3.jpeg", rarity: "c" },
        { file: "31c2d10b-7f52-41f0-b4c9-05eecc61afb2-0_0.jpeg", rarity: "c" },
        { file: "31c2d10b-7f52-41f0-b4c9-05eecc61afb2-0_1.jpeg", rarity: "c" },
        { file: "31c2d10b-7f52-41f0-b4c9-05eecc61afb2-0_2.jpeg", rarity: "c" },
        { file: "36e72b54-063b-4386-a3a3-0be761645e46-0_0.jpeg", rarity: "c" },
        { file: "36e72b54-063b-4386-a3a3-0be761645e46-0_1.jpeg", rarity: "c" },
        { file: "36e72b54-063b-4386-a3a3-0be761645e46-0_2.jpeg", rarity: "c" },
        { file: "36e72b54-063b-4386-a3a3-0be761645e46-0_3.jpeg", rarity: "c" },
        { file: "3c98a0ee-f6ad-478f-9bf1-2e832ea82035-0_0.jpeg", rarity: "c" },
        { file: "3dc1a70c-2184-41e5-9bf3-124e67038426-0_2.jpeg", rarity: "c" },
        { file: "53b0a484-d41e-4085-8082-39a33ebb465f-0_0.jpeg", rarity: "c" },
        { file: "53b0a484-d41e-4085-8082-39a33ebb465f-0_1.jpeg", rarity: "c" },
        { file: "53b0a484-d41e-4085-8082-39a33ebb465f-0_3.jpeg", rarity: "c" },
        { file: "67c716c3-0b01-46f4-af47-c89fe60c7db8-0_0.jpeg", rarity: "c" },
        { file: "88987592-e460-4556-9344-22dfc87277c9-0_0.jpeg", rarity: "c" },
        { file: "88987592-e460-4556-9344-22dfc87277c9-0_1.jpeg", rarity: "c" },
        { file: "88987592-e460-4556-9344-22dfc87277c9-0_2.jpeg", rarity: "c" },
        { file: "88987592-e460-4556-9344-22dfc87277c9-0_3.jpeg", rarity: "c" },
        { file: "c53976da-1160-4f62-a141-88e4ce7a85f7-0_1.jpeg", rarity: "c" },
        { file: "cd5576af-a3bc-478a-adb0-20bea163fcd0-0_0.jpeg", rarity: "c" },
        { file: "cd5576af-a3bc-478a-adb0-20bea163fcd0-0_1.jpeg", rarity: "c" },
        { file: "cd5576af-a3bc-478a-adb0-20bea163fcd0-0_2.jpeg", rarity: "c" },
        { file: "cd5576af-a3bc-478a-adb0-20bea163fcd0-0_3.jpeg", rarity: "c" },
        { file: "d9cf966e-2a61-4a88-bc2a-a8b761c18d14-0_0.jpeg", rarity: "c" },
        { file: "d9cf966e-2a61-4a88-bc2a-a8b761c18d14-0_1.jpeg", rarity: "c" },
        { file: "d9cf966e-2a61-4a88-bc2a-a8b761c18d14-0_3.jpeg", rarity: "c" },
        { file: "e6e3a946-a681-4239-8ed4-1c2e41c69b47-0_3.jpeg", rarity: "c" },
        { file: "f9fdfe19-3661-4922-a2c4-c35a671046f2-0_0.jpeg", rarity: "c" },
        { file: "f9fdfe19-3661-4922-a2c4-c35a671046f2-0_2.jpeg", rarity: "c" },
        { file: "f9fdfe19-3661-4922-a2c4-c35a671046f2-0_3.jpeg", rarity: "c" },
        { file: "fe19f514-14e5-415b-9f9a-2cd506c8f72b-0_1.jpeg", rarity: "c" },
        { file: "fe19f514-14e5-415b-9f9a-2cd506c8f72b-0_3.jpeg", rarity: "c" },
    ],
    gobelin: [
        { file: "1bb295e6-704b-4825-a41d-081b82aa213f-0_0.jpeg", rarity: "c" },
        { file: "1bb295e6-704b-4825-a41d-081b82aa213f-0_1.jpeg", rarity: "c" },
        { file: "1bb295e6-704b-4825-a41d-081b82aa213f-0_2.jpeg", rarity: "c" },
        { file: "1bb295e6-704b-4825-a41d-081b82aa213f-0_3.jpeg", rarity: "c" },
        { file: "52a44c77-9079-4929-bbe5-746fcf2a3ee9-0_0.jpeg", rarity: "c" },
        { file: "52a44c77-9079-4929-bbe5-746fcf2a3ee9-0_1.jpeg", rarity: "c" },
        { file: "52a44c77-9079-4929-bbe5-746fcf2a3ee9-0_2.jpeg", rarity: "c" },
        { file: "52a44c77-9079-4929-bbe5-746fcf2a3ee9-0_3.jpeg", rarity: "c" },
        { file: "64a08389-662a-46e3-a2bb-a23def31942a-0_0.jpeg", rarity: "c" },
        { file: "64a08389-662a-46e3-a2bb-a23def31942a-0_1.jpeg", rarity: "c" },
        { file: "64a08389-662a-46e3-a2bb-a23def31942a-0_2.jpeg", rarity: "c" },
        { file: "64a08389-662a-46e3-a2bb-a23def31942a-0_3.jpeg", rarity: "c" },
        { file: "c64d5eb4-2e2d-403e-a7e2-0395e1af245a-0_3.jpeg", rarity: "c" },
    ],
    halfing: [
        { file: "66821d3c-cf4b-4189-95a7-37984718d546-0_0.jpeg", rarity: "c" },
        { file: "7d489f8a-f0bc-4370-90da-9c4f7f30e6de-0_2.jpeg", rarity: "c" },
        { file: "8969bb3e-20f0-4bdb-812f-7763eb59f07c-0_0.jpeg", rarity: "c" },
        { file: "8969bb3e-20f0-4bdb-812f-7763eb59f07c-0_2.jpeg", rarity: "c" },
        { file: "e47a868d-c806-4150-82de-2e3fdf3719b7-0_0.jpeg", rarity: "c" },
        { file: "e47a868d-c806-4150-82de-2e3fdf3719b7-0_1.jpeg", rarity: "c" },
        { file: "e47a868d-c806-4150-82de-2e3fdf3719b7-0_2.jpeg", rarity: "c" },
        { file: "e47a868d-c806-4150-82de-2e3fdf3719b7-0_3.jpeg", rarity: "c" },
    ],
    human: [
        { file: "0bc704b6-1912-4293-aef9-14252e2becfd-0_0.jpeg", rarity: "c" },
        { file: "0bc704b6-1912-4293-aef9-14252e2becfd-0_3.jpeg", rarity: "c" },
        { file: "0fd0b6db-1216-47ee-9694-76dd17a015c3-0_0.jpeg", rarity: "c" },
        { file: "1485415c-4ce4-4381-9ec3-5690f315ed11-0_1.jpeg", rarity: "c" },
        { file: "1485415c-4ce4-4381-9ec3-5690f315ed11-0_2.jpeg", rarity: "c" },
        { file: "1485415c-4ce4-4381-9ec3-5690f315ed11-0_3.jpeg", rarity: "c" },
        { file: "1a36a389-e748-41a3-b286-eaa64dd66a92-0_2.jpeg", rarity: "c" },
        { file: "276b7837-0ab1-4581-a3b8-cfd4bbbe511e-0_0.jpeg", rarity: "c" },
        { file: "276b7837-0ab1-4581-a3b8-cfd4bbbe511e-0_2.jpeg", rarity: "c" },
        { file: "276b7837-0ab1-4581-a3b8-cfd4bbbe511e-0_3.jpeg", rarity: "c" },
        { file: "305182b7-cfab-4aff-aad5-e6633d3ba89a-0_1.jpeg", rarity: "c" },
        { file: "305182b7-cfab-4aff-aad5-e6633d3ba89a-0_2.jpeg", rarity: "c" },
        { file: "305182b7-cfab-4aff-aad5-e6633d3ba89a-0_3.jpeg", rarity: "c" },
        { file: "42191054-cc4e-4f98-9a3f-266901878ec4-0_0.jpeg", rarity: "c" },
        { file: "42191054-cc4e-4f98-9a3f-266901878ec4-0_1.jpeg", rarity: "c" },
        { file: "42191054-cc4e-4f98-9a3f-266901878ec4-0_2.jpeg", rarity: "c" },
        { file: "53b0a484-d41e-4085-8082-39a33ebb465f-0_2.jpeg", rarity: "c" },
        { file: "5e285332-034e-4513-85ea-46ab7e0895db-0_1.jpeg", rarity: "c" },
        { file: "5e285332-034e-4513-85ea-46ab7e0895db-0_2.jpeg", rarity: "c" },
        { file: "5e285332-034e-4513-85ea-46ab7e0895db-0_3.jpeg", rarity: "c" },
        { file: "60fd15a1-72c1-4b51-b510-0db8b678b567-0_3.jpeg", rarity: "c" },
        { file: "66111b6f-c26e-4f4e-bc14-f6a8c260f43c-0_0.jpeg", rarity: "c" },
        { file: "66111b6f-c26e-4f4e-bc14-f6a8c260f43c-0_2.jpeg", rarity: "c" },
        { file: "66111b6f-c26e-4f4e-bc14-f6a8c260f43c-0_3.jpeg", rarity: "c" },
        { file: "675f0c55-1fea-4d38-b9b7-e0595fc37086-0_0.jpeg", rarity: "c" },
        { file: "675f0c55-1fea-4d38-b9b7-e0595fc37086-0_1.jpeg", rarity: "c" },
        { file: "675f0c55-1fea-4d38-b9b7-e0595fc37086-0_2.jpeg", rarity: "c" },
        { file: "675f0c55-1fea-4d38-b9b7-e0595fc37086-0_3.jpeg", rarity: "c" },
        { file: "7ee49ae2-9d06-4235-b00d-c731da4b8f01-0_2.jpeg", rarity: "c" },
        { file: "7ee49ae2-9d06-4235-b00d-c731da4b8f01-0_3.jpeg", rarity: "c" },
        { file: "87876ad9-80ab-4cef-a8c2-c47289113efe-0_0.jpeg", rarity: "c" },
        { file: "96169e70-b67a-4453-bb34-a7cbcc1b6b29-0_0.jpeg", rarity: "c" },
        { file: "96169e70-b67a-4453-bb34-a7cbcc1b6b29-0_1.jpeg", rarity: "c" },
        { file: "96169e70-b67a-4453-bb34-a7cbcc1b6b29-0_2.jpeg", rarity: "c" },
        { file: "96169e70-b67a-4453-bb34-a7cbcc1b6b29-0_3.jpeg", rarity: "c" },
        { file: "9689553d-8ce2-498b-88fd-8557ac614407-0_0.jpeg", rarity: "c" },
        { file: "9689553d-8ce2-498b-88fd-8557ac614407-0_3.jpeg", rarity: "c" },
        { file: "9ff4c1a1-55a3-48c9-b388-04ed64150699-0_0.jpeg", rarity: "c" },
        { file: "9ff4c1a1-55a3-48c9-b388-04ed64150699-0_1.jpeg", rarity: "c" },
        { file: "9ff4c1a1-55a3-48c9-b388-04ed64150699-0_2.jpeg", rarity: "c" },
        { file: "9ff4c1a1-55a3-48c9-b388-04ed64150699-0_3.jpeg", rarity: "c" },
        { file: "a5907074-ac56-40f8-9c5d-cfbbd35290f2-0_0.jpeg", rarity: "c" },
        { file: "a5907074-ac56-40f8-9c5d-cfbbd35290f2-0_1.jpeg", rarity: "c" },
        { file: "a5907074-ac56-40f8-9c5d-cfbbd35290f2-0_3.jpeg", rarity: "c" },
        { file: "be8cf67b-3d2d-4e95-a7be-de84b573a88f-0_0.jpeg", rarity: "c" },
        { file: "be8cf67b-3d2d-4e95-a7be-de84b573a88f-0_2.jpeg", rarity: "c" },
        { file: "be8cf67b-3d2d-4e95-a7be-de84b573a88f-0_3.jpeg", rarity: "c" },
        { file: "c53976da-1160-4f62-a141-88e4ce7a85f7-0_2.jpeg", rarity: "c" },
        { file: "c53976da-1160-4f62-a141-88e4ce7a85f7-0_3.jpeg", rarity: "c" },
        { file: "d6f9142b-6ad4-4c33-b96a-bb928baf707d-0_1.jpeg", rarity: "c" },
        { file: "d9cf966e-2a61-4a88-bc2a-a8b761c18d14-0_2.jpeg", rarity: "c" },
        { file: "dfba89be-90ae-4509-bbee-22722e13b8e2-0_0.jpeg", rarity: "c" },
        { file: "dfba89be-90ae-4509-bbee-22722e13b8e2-0_1.jpeg", rarity: "c" },
        { file: "dfba89be-90ae-4509-bbee-22722e13b8e2-0_2.jpeg", rarity: "c" },
        { file: "dfba89be-90ae-4509-bbee-22722e13b8e2-0_3.jpeg", rarity: "c" },
        { file: "f6854414-ce56-493b-bb11-6bfa04b28fa2-0_0.jpeg", rarity: "c" },
        { file: "f6854414-ce56-493b-bb11-6bfa04b28fa2-0_1.jpeg", rarity: "c" },
        { file: "f6854414-ce56-493b-bb11-6bfa04b28fa2-0_2.jpeg", rarity: "c" },
        { file: "f91ac586-dece-45ee-9e61-d4aa20ec9982-0_1.jpeg", rarity: "c" },
        { file: "f91ac586-dece-45ee-9e61-d4aa20ec9982-0_2.jpeg", rarity: "c" },
        { file: "f91ac586-dece-45ee-9e61-d4aa20ec9982-0_3.jpeg", rarity: "c" },
    ],
    "human-woman": [
        { file: "06342dab-92be-4ce8-9ec5-d8bec62ce43d-0_0.jpeg", rarity: "c" },
        { file: "06342dab-92be-4ce8-9ec5-d8bec62ce43d-0_1.jpeg", rarity: "c" },
        { file: "06342dab-92be-4ce8-9ec5-d8bec62ce43d-0_3.jpeg", rarity: "c" },
        { file: "0a77aa8f-8b01-451d-9b30-91bb211cfc1b-0_1.jpeg", rarity: "c" },
        { file: "0a7b1fff-581a-4a6c-b55c-f838e0d5a4c9-0_1.jpeg", rarity: "c" },
        { file: "0d93a543-0621-49d4-b569-75be58a2a6a5-0_0.jpeg", rarity: "c" },
        { file: "0d93a543-0621-49d4-b569-75be58a2a6a5-0_2.jpeg", rarity: "c" },
        { file: "0d93a543-0621-49d4-b569-75be58a2a6a5-0_3.jpeg", rarity: "c" },
        { file: "1015f692-090b-467f-8124-18811ac61bf2-0_2.jpeg", rarity: "c" },
        { file: "1015f692-090b-467f-8124-18811ac61bf2-0_3.jpeg", rarity: "c" },
        { file: "31c2d10b-7f52-41f0-b4c9-05eecc61afb2-0_3.jpeg", rarity: "c" },
        { file: "35210f23-19a9-402e-a7b4-26fcfa715270-0_0.jpeg", rarity: "c" },
        { file: "35210f23-19a9-402e-a7b4-26fcfa715270-0_1.jpeg", rarity: "c" },
        { file: "35210f23-19a9-402e-a7b4-26fcfa715270-0_2.jpeg", rarity: "c" },
        { file: "35210f23-19a9-402e-a7b4-26fcfa715270-0_3.jpeg", rarity: "c" },
        { file: "3dc1a70c-2184-41e5-9bf3-124e67038426-0_0.jpeg", rarity: "c" },
        { file: "3dc1a70c-2184-41e5-9bf3-124e67038426-0_1.jpeg", rarity: "c" },
        { file: "3dc1a70c-2184-41e5-9bf3-124e67038426-0_2.jpeg", rarity: "c" },
        { file: "3dc1a70c-2184-41e5-9bf3-124e67038426-0_3.jpeg", rarity: "c" },
        { file: "55b43724-4e61-4380-a727-a71a8133f7ce-0_0.jpeg", rarity: "c" },
        { file: "55b43724-4e61-4380-a727-a71a8133f7ce-0_1.jpeg", rarity: "c" },
        { file: "55b43724-4e61-4380-a727-a71a8133f7ce-0_2.jpeg", rarity: "c" },
        { file: "55b43724-4e61-4380-a727-a71a8133f7ce-0_3.jpeg", rarity: "c" },
        { file: "684ac578-5459-45e0-b295-591036a5ee36-0_0.jpeg", rarity: "c" },
        { file: "684ac578-5459-45e0-b295-591036a5ee36-0_1.jpeg", rarity: "c" },
        { file: "684ac578-5459-45e0-b295-591036a5ee36-0_2.jpeg", rarity: "c" },
        { file: "684ac578-5459-45e0-b295-591036a5ee36-0_3.jpeg", rarity: "c" },
        { file: "abc5ea2e-0a48-45a6-ba92-648b85afdc5e-0_0.jpeg", rarity: "c" },
        { file: "abc5ea2e-0a48-45a6-ba92-648b85afdc5e-0_1.jpeg", rarity: "c" },
        { file: "abc5ea2e-0a48-45a6-ba92-648b85afdc5e-0_2.jpeg", rarity: "c" },
        { file: "abc5ea2e-0a48-45a6-ba92-648b85afdc5e-0_3.jpeg", rarity: "c" },
        { file: "d9cf966e-2a61-4a88-bc2a-a8b761c18d14-0_1.jpeg", rarity: "c" },
        { file: "eddf87b3-c4f9-4836-af70-b94ad0868ff2-0_0.jpeg", rarity: "c" },
        { file: "eddf87b3-c4f9-4836-af70-b94ad0868ff2-0_1.jpeg", rarity: "c" },
        { file: "eddf87b3-c4f9-4836-af70-b94ad0868ff2-0_2.jpeg", rarity: "c" },
        { file: "eddf87b3-c4f9-4836-af70-b94ad0868ff2-0_3.jpeg", rarity: "c" },
        { file: "f4cba3ef-8ac1-4a8c-9b1f-7c58720ef14c-0_2.jpeg", rarity: "c" },
        { file: "f9fdfe19-3661-4922-a2c4-c35a671046f2-0_0.jpeg", rarity: "c" },
        { file: "f9fdfe19-3661-4922-a2c4-c35a671046f2-0_1.jpeg", rarity: "c" },
        { file: "f9fdfe19-3661-4922-a2c4-c35a671046f2-0_3.jpeg", rarity: "c" },
    ],
    lezard: [
        { file: "16229268-6159-4848-a5c4-c401edf34a63-0_0.jpeg", rarity: "c" },
        { file: "16229268-6159-4848-a5c4-c401edf34a63-0_1.jpeg", rarity: "c" },
        { file: "16229268-6159-4848-a5c4-c401edf34a63-0_3.jpeg", rarity: "c" },
        { file: "5e161027-a1ef-4e83-826b-b440a31f580c-0_2.jpeg", rarity: "c" },
        { file: "629d612b-cb03-41bd-b547-badedc8ff88e-0_0.jpeg", rarity: "c" },
        { file: "629d612b-cb03-41bd-b547-badedc8ff88e-0_1.jpeg", rarity: "c" },
        { file: "629d612b-cb03-41bd-b547-badedc8ff88e-0_2.jpeg", rarity: "c" },
        { file: "629d612b-cb03-41bd-b547-badedc8ff88e-0_3.jpeg", rarity: "c" },
        { file: "7080a2fc-7325-44d9-9372-691beeb3dcc0-0_0.jpeg", rarity: "c" },
        { file: "7080a2fc-7325-44d9-9372-691beeb3dcc0-0_1.jpeg", rarity: "c" },
        { file: "7080a2fc-7325-44d9-9372-691beeb3dcc0-0_2.jpeg", rarity: "c" },
        { file: "7080a2fc-7325-44d9-9372-691beeb3dcc0-0_3.jpeg", rarity: "c" },
        { file: "8844feeb-a593-406b-af08-9fc502ea3035-0_0.jpeg", rarity: "c" },
        { file: "8844feeb-a593-406b-af08-9fc502ea3035-0_1.jpeg", rarity: "c" },
        { file: "8844feeb-a593-406b-af08-9fc502ea3035-0_2.jpeg", rarity: "c" },
        { file: "8844feeb-a593-406b-af08-9fc502ea3035-0_3.jpeg", rarity: "c" },
        { file: "96a21984-6c03-4da3-8559-8b57f3cc1986-0_0.jpeg", rarity: "c" },
        { file: "96a21984-6c03-4da3-8559-8b57f3cc1986-0_1.jpeg", rarity: "c" },
        { file: "96a21984-6c03-4da3-8559-8b57f3cc1986-0_2.jpeg", rarity: "c" },
        { file: "a94e26e3-9f94-417d-9c0c-2e96c0bb1d54-0_1.jpeg", rarity: "c" },
        { file: "a94e26e3-9f94-417d-9c0c-2e96c0bb1d54-0_3.jpeg", rarity: "c" },
        { file: "cf2d56d2-9165-42a9-b4e0-8970401d0922-0_0.jpeg", rarity: "c" },
        { file: "cf2d56d2-9165-42a9-b4e0-8970401d0922-0_1.jpeg", rarity: "c" },
        { file: "cf2d56d2-9165-42a9-b4e0-8970401d0922-0_2.jpeg", rarity: "c" },
        { file: "d0007e3f-6910-4589-868c-01f33d8dc83f-0_0.jpeg", rarity: "c" },
        { file: "d0007e3f-6910-4589-868c-01f33d8dc83f-0_1.jpeg", rarity: "c" },
        { file: "d0007e3f-6910-4589-868c-01f33d8dc83f-0_2.jpeg", rarity: "c" },
        { file: "d0007e3f-6910-4589-868c-01f33d8dc83f-0_3.jpeg", rarity: "c" },
    ],
    minotaur: [
        { file: "316535f2-0a59-4b82-92dc-37b5377a0f34-0_0.jpeg", rarity: "c" },
        { file: "316535f2-0a59-4b82-92dc-37b5377a0f34-0_1.jpeg", rarity: "c" },
        { file: "4a741cce-7b3c-4d78-b709-0ae55c1d4ae0-0_0.jpeg", rarity: "c" },
        { file: "67c716c3-0b01-46f4-af47-c89fe60c7db8-0_2.jpeg", rarity: "c" },
        { file: "72a0f531-68c7-46a4-af59-078ecaf891fb-0_0.jpeg", rarity: "c" },
        { file: "72a0f531-68c7-46a4-af59-078ecaf891fb-0_1.jpeg", rarity: "c" },
        { file: "72a0f531-68c7-46a4-af59-078ecaf891fb-0_2.jpeg", rarity: "c" },
        { file: "72a0f531-68c7-46a4-af59-078ecaf891fb-0_3.jpeg", rarity: "c" },
        { file: "7c01b50e-f494-4f57-86ad-3ec58cf159d1-0_1.jpeg", rarity: "c" },
        { file: "7c01b50e-f494-4f57-86ad-3ec58cf159d1-0_3.jpeg", rarity: "c" },
        { file: "ada45efb-b266-43a4-b5d5-6f89eb357b6a-0_2.jpeg", rarity: "c" },
        { file: "c5f43368-72bf-4a45-8ecb-fe5a2e3d0eb9-0_0.jpeg", rarity: "c" },
        { file: "c5f43368-72bf-4a45-8ecb-fe5a2e3d0eb9-0_1.jpeg", rarity: "c" },
        { file: "c5f43368-72bf-4a45-8ecb-fe5a2e3d0eb9-0_2.jpeg", rarity: "c" },
        { file: "c5f43368-72bf-4a45-8ecb-fe5a2e3d0eb9-0_3.jpeg", rarity: "c" },
        { file: "ed526104-8494-431c-9235-5c04c473a1cf-0_0.jpeg", rarity: "c" },
        { file: "ed526104-8494-431c-9235-5c04c473a1cf-0_3.jpeg", rarity: "c" },
    ],
    mummie: [
        { file: "0872498c-ac73-4b33-a99c-ae2c78b1c2e9-0_0.jpeg", rarity: "c" },
        { file: "0872498c-ac73-4b33-a99c-ae2c78b1c2e9-0_1.jpeg", rarity: "c" },
        { file: "0872498c-ac73-4b33-a99c-ae2c78b1c2e9-0_3.jpeg", rarity: "c" },
        { file: "93344aed-b625-48ca-be22-8debcfb96799-0_1.jpeg", rarity: "c" },
        { file: "93344aed-b625-48ca-be22-8debcfb96799-0_2.jpeg", rarity: "c" },
        { file: "93344aed-b625-48ca-be22-8debcfb96799-0_3.jpeg", rarity: "c" },
        { file: "fe7927ea-724f-47a2-8db3-777d41697cdf-0_0.jpeg", rarity: "c" },
    ],
    ogre: [
        { file: "42191054-cc4e-4f98-9a3f-266901878ec4-0_3.jpeg", rarity: "c" },
        { file: "4e040f3d-184a-46bb-b915-d879c4c7864b-0_0.jpeg", rarity: "c" },
        { file: "4e040f3d-184a-46bb-b915-d879c4c7864b-0_1.jpeg", rarity: "c" },
        { file: "4e040f3d-184a-46bb-b915-d879c4c7864b-0_2.jpeg", rarity: "c" },
        { file: "60dfb4ec-a9b4-484f-9fd6-cf6162d4abde-0_0.jpeg", rarity: "c" },
        { file: "60dfb4ec-a9b4-484f-9fd6-cf6162d4abde-0_2.jpeg", rarity: "c" },
        { file: "60dfb4ec-a9b4-484f-9fd6-cf6162d4abde-0_3.jpeg", rarity: "c" },
        { file: "7c91dbc5-0cad-4640-9ad8-cb65badde91d-0_2.jpeg", rarity: "c" },
        { file: "8c26f35a-3c0d-46d6-87a7-b472314193c9-0_3.jpeg", rarity: "c" },
        { file: "a06af098-e5fc-44bb-b6c7-12c0e976331b-0_3.jpeg", rarity: "c" },
        { file: "ada45efb-b266-43a4-b5d5-6f89eb357b6a-0_1.jpeg", rarity: "c" },
        { file: "e1220979-43a5-4c97-80b3-85a4a6dd7830-0_0.jpeg", rarity: "c" },
        { file: "e1220979-43a5-4c97-80b3-85a4a6dd7830-0_2.jpeg", rarity: "c" },
        { file: "ef2361a9-b015-4757-b1ba-b6b561dbbcb0-0_2.jpeg", rarity: "c" },
        { file: "fb115f45-323f-4058-91d3-bb9f039e5916-0_0.jpeg", rarity: "c" },
        { file: "fb115f45-323f-4058-91d3-bb9f039e5916-0_1.jpeg", rarity: "c" },
        { file: "fb115f45-323f-4058-91d3-bb9f039e5916-0_2.jpeg", rarity: "c" },
        { file: "fb115f45-323f-4058-91d3-bb9f039e5916-0_3.jpeg", rarity: "c" },
    ],
    orc: [
        { file: "0f8abb27-96ea-457a-8e7f-16e01d4d10e6-0_0.jpeg", rarity: "c" },
        { file: "0f8abb27-96ea-457a-8e7f-16e01d4d10e6-0_1.jpeg", rarity: "c" },
        { file: "0f8abb27-96ea-457a-8e7f-16e01d4d10e6-0_2.jpeg", rarity: "c" },
        { file: "0f8abb27-96ea-457a-8e7f-16e01d4d10e6-0_3.jpeg", rarity: "c" },
        { file: "2ce2614c-3971-41a5-b2ce-c4c5bfde9741-0_1.jpeg", rarity: "c" },
        { file: "2ce2614c-3971-41a5-b2ce-c4c5bfde9741-0_2.jpeg", rarity: "c" },
        { file: "2ce2614c-3971-41a5-b2ce-c4c5bfde9741-0_3.jpeg", rarity: "c" },
        { file: "5510fcdf-9a3b-4818-bb35-0b715018d80a-0_0.jpeg", rarity: "c" },
        { file: "5510fcdf-9a3b-4818-bb35-0b715018d80a-0_1.jpeg", rarity: "c" },
        { file: "5510fcdf-9a3b-4818-bb35-0b715018d80a-0_2.jpeg", rarity: "c" },
        { file: "5510fcdf-9a3b-4818-bb35-0b715018d80a-0_3.jpeg", rarity: "c" },
        { file: "56fb163e-dd5b-442d-a197-ed41863f083c-0_0.jpeg", rarity: "c" },
        { file: "56fb163e-dd5b-442d-a197-ed41863f083c-0_2.jpeg", rarity: "c" },
        { file: "56fb163e-dd5b-442d-a197-ed41863f083c-0_3.jpeg", rarity: "c" },
        { file: "60dfb4ec-a9b4-484f-9fd6-cf6162d4abde-0_1.jpeg", rarity: "c" },
        { file: "7b2c8848-5907-4e14-9103-116a7234616c-0_2.jpeg", rarity: "c" },
        { file: "7c91dbc5-0cad-4640-9ad8-cb65badde91d-0_0.jpeg", rarity: "c" },
        { file: "7c91dbc5-0cad-4640-9ad8-cb65badde91d-0_3.jpeg", rarity: "c" },
        { file: "9b362e57-47a7-460c-b512-9620eb84f65b-0_0.jpeg", rarity: "c" },
        { file: "9b362e57-47a7-460c-b512-9620eb84f65b-0_1.jpeg", rarity: "c" },
        { file: "9b362e57-47a7-460c-b512-9620eb84f65b-0_2.jpeg", rarity: "c" },
        { file: "9b362e57-47a7-460c-b512-9620eb84f65b-0_3.jpeg", rarity: "c" },
        { file: "b6280ccb-73ba-4776-930e-0e10de1a931d-0_0.jpeg", rarity: "c" },
        { file: "b6280ccb-73ba-4776-930e-0e10de1a931d-0_1.jpeg", rarity: "c" },
        { file: "b6280ccb-73ba-4776-930e-0e10de1a931d-0_3.jpeg", rarity: "c" },
        { file: "bb8857da-4245-4f57-a8cb-c71f042cfed8-0_0.jpeg", rarity: "c" },
        { file: "bb8857da-4245-4f57-a8cb-c71f042cfed8-0_1.jpeg", rarity: "c" },
        { file: "bb8857da-4245-4f57-a8cb-c71f042cfed8-0_2.jpeg", rarity: "c" },
        { file: "bb8857da-4245-4f57-a8cb-c71f042cfed8-0_3.jpeg", rarity: "c" },
        { file: "c648ed33-541c-43c2-acea-24f85cc475c5-0_1.jpeg", rarity: "c" },
        { file: "c648ed33-541c-43c2-acea-24f85cc475c5-0_2.jpeg", rarity: "c" },
        { file: "c648ed33-541c-43c2-acea-24f85cc475c5-0_3.jpeg", rarity: "c" },
        { file: "d7209622-3e92-48aa-ac79-023a03e15481-0_1.jpeg", rarity: "c" },
        { file: "d7209622-3e92-48aa-ac79-023a03e15481-0_3.jpeg", rarity: "c" },
        { file: "da190890-c3f2-4fd7-beb9-48f5f5ad0f37-0_0.jpeg", rarity: "c" },
        { file: "da190890-c3f2-4fd7-beb9-48f5f5ad0f37-0_1.jpeg", rarity: "c" },
        { file: "da190890-c3f2-4fd7-beb9-48f5f5ad0f37-0_2.jpeg", rarity: "c" },
        { file: "da190890-c3f2-4fd7-beb9-48f5f5ad0f37-0_3.jpeg", rarity: "c" },
        { file: "daada4ad-d490-4f63-b0fb-d390acf1b4d0-0_3.jpeg", rarity: "c" },
        { file: "e1220979-43a5-4c97-80b3-85a4a6dd7830-0_1.jpeg", rarity: "c" },
        { file: "e1220979-43a5-4c97-80b3-85a4a6dd7830-0_3.jpeg", rarity: "c" },
        { file: "f4931ac0-ffde-483d-879b-e633cefb9fab-0_2.jpeg", rarity: "c" },
        { file: "f4931ac0-ffde-483d-879b-e633cefb9fab-0_3.jpeg", rarity: "c" },
        { file: "fe7cc1dc-e185-47ac-82a4-f892d7b62620-0_0.jpeg", rarity: "c" },
        { file: "fe7cc1dc-e185-47ac-82a4-f892d7b62620-0_3.jpeg", rarity: "c" },
    ],
    rat: [
        { file: "37c571c6-cafa-48d8-a031-c3c8dec92a37-0_0.jpeg", rarity: "c" },
        { file: "37c571c6-cafa-48d8-a031-c3c8dec92a37-0_1.jpeg", rarity: "c" },
        { file: "37c571c6-cafa-48d8-a031-c3c8dec92a37-0_2.jpeg", rarity: "c" },
        { file: "37c571c6-cafa-48d8-a031-c3c8dec92a37-0_3.jpeg", rarity: "c" },
        { file: "55c71c47-cb5c-4185-9e95-5bf4fe00b00b-0_0.jpeg", rarity: "c" },
        { file: "55c71c47-cb5c-4185-9e95-5bf4fe00b00b-0_1.jpeg", rarity: "c" },
        { file: "55c71c47-cb5c-4185-9e95-5bf4fe00b00b-0_2.jpeg", rarity: "c" },
        { file: "55c71c47-cb5c-4185-9e95-5bf4fe00b00b-0_3.jpeg", rarity: "c" },
        { file: "5b376685-0d67-4426-8eca-dc013c2a09a4-0_0.jpeg", rarity: "c" },
        { file: "5b376685-0d67-4426-8eca-dc013c2a09a4-0_1.jpeg", rarity: "c" },
        { file: "5b376685-0d67-4426-8eca-dc013c2a09a4-0_2.jpeg", rarity: "c" },
        { file: "5b376685-0d67-4426-8eca-dc013c2a09a4-0_3.jpeg", rarity: "c" },
        { file: "72b64669-9690-4d65-9b2a-e7f49a5068b7-0_0.jpeg", rarity: "c" },
        { file: "72b64669-9690-4d65-9b2a-e7f49a5068b7-0_1.jpeg", rarity: "c" },
        { file: "72b64669-9690-4d65-9b2a-e7f49a5068b7-0_2.jpeg", rarity: "c" },
        { file: "72b64669-9690-4d65-9b2a-e7f49a5068b7-0_3.jpeg", rarity: "c" },
        { file: "c82205fa-ca65-47f8-a5dc-e763d5c06bd0-0_0.jpeg", rarity: "c" },
        { file: "c82205fa-ca65-47f8-a5dc-e763d5c06bd0-0_1.jpeg", rarity: "c" },
        { file: "c82205fa-ca65-47f8-a5dc-e763d5c06bd0-0_2.jpeg", rarity: "c" },
        { file: "c82205fa-ca65-47f8-a5dc-e763d5c06bd0-0_3.jpeg", rarity: "c" },
        { file: "cbf304a6-c96e-4d47-b8cc-d65b1775dcdb-0_0.jpeg", rarity: "c" },
        { file: "cbf304a6-c96e-4d47-b8cc-d65b1775dcdb-0_1.jpeg", rarity: "c" },
        { file: "cbf304a6-c96e-4d47-b8cc-d65b1775dcdb-0_2.jpeg", rarity: "c" },
        { file: "cbf304a6-c96e-4d47-b8cc-d65b1775dcdb-0_3.jpeg", rarity: "c" },
        { file: "f9915d6d-c877-4ebc-ac2f-97d59a60143f-0_0.jpeg", rarity: "c" },
        { file: "f9915d6d-c877-4ebc-ac2f-97d59a60143f-0_1.jpeg", rarity: "c" },
        { file: "f9915d6d-c877-4ebc-ac2f-97d59a60143f-0_2.jpeg", rarity: "c" },
        { file: "f9915d6d-c877-4ebc-ac2f-97d59a60143f-0_3.jpeg", rarity: "c" },
    ],
    treeman: [
        { file: "51bdeabf-447d-4fd8-abe2-9dcc0cdc19f5-0_0.jpeg", rarity: "c" },
        { file: "51bdeabf-447d-4fd8-abe2-9dcc0cdc19f5-0_1.jpeg", rarity: "c" },
        { file: "51bdeabf-447d-4fd8-abe2-9dcc0cdc19f5-0_2.jpeg", rarity: "c" },
    ],
    troll: [
        { file: "09fe73e8-f46b-4a10-ab63-db96d8f21e44-0_0.jpeg", rarity: "c" },
        { file: "56fb163e-dd5b-442d-a197-ed41863f083c-0_1.jpeg", rarity: "c" },
        { file: "7b2c8848-5907-4e14-9103-116a7234616c-0_0.jpeg", rarity: "c" },
        { file: "7b2c8848-5907-4e14-9103-116a7234616c-0_1.jpeg", rarity: "c" },
        { file: "7b2c8848-5907-4e14-9103-116a7234616c-0_3.jpeg", rarity: "c" },
        { file: "ef2361a9-b015-4757-b1ba-b6b561dbbcb0-0_1.jpeg", rarity: "c" },
        { file: "fbc0db65-dbba-487d-88d2-3411ba4141b9-0_3.jpeg", rarity: "c" },
    ],
    undead: [
        { file: "0fd0b6db-1216-47ee-9694-76dd17a015c3-0_1.jpeg", rarity: "c" },
        { file: "0fd0b6db-1216-47ee-9694-76dd17a015c3-0_2.jpeg", rarity: "c" },
        { file: "3d27a2cd-840c-435e-a8b2-3cebfa220f0a-0_0.jpeg", rarity: "c" },
        { file: "3d27a2cd-840c-435e-a8b2-3cebfa220f0a-0_2.jpeg", rarity: "c" },
        { file: "3d27a2cd-840c-435e-a8b2-3cebfa220f0a-0_3.jpeg", rarity: "c" },
        { file: "513e9dbf-20b4-45e5-923f-1ab25bf4b077-0_0.jpeg", rarity: "c" },
        { file: "513e9dbf-20b4-45e5-923f-1ab25bf4b077-0_1.jpeg", rarity: "c" },
        { file: "513e9dbf-20b4-45e5-923f-1ab25bf4b077-0_2.jpeg", rarity: "c" },
        { file: "513e9dbf-20b4-45e5-923f-1ab25bf4b077-0_3.jpeg", rarity: "c" },
        { file: "67c716c3-0b01-46f4-af47-c89fe60c7db8-0_1.jpeg", rarity: "c" },
        { file: "87876ad9-80ab-4cef-a8c2-c47289113efe-0_1.jpeg", rarity: "c" },
        { file: "87876ad9-80ab-4cef-a8c2-c47289113efe-0_3.jpeg", rarity: "c" },
        { file: "a3d2571e-5b07-4ed5-8e59-b36c09ea8020-0_0.jpeg", rarity: "c" },
        { file: "a3d2571e-5b07-4ed5-8e59-b36c09ea8020-0_1.jpeg", rarity: "c" },
        { file: "a3d2571e-5b07-4ed5-8e59-b36c09ea8020-0_2.jpeg", rarity: "c" },
        { file: "a3d2571e-5b07-4ed5-8e59-b36c09ea8020-0_3.jpeg", rarity: "c" },
        { file: "be8cf67b-3d2d-4e95-a7be-de84b573a88f-0_1.jpeg", rarity: "c" },
        { file: "c1a5b469-0ba6-4027-905a-ba2606ca8c6e-0_0.jpeg", rarity: "c" },
        { file: "c1a5b469-0ba6-4027-905a-ba2606ca8c6e-0_1.jpeg", rarity: "c" },
        { file: "c1a5b469-0ba6-4027-905a-ba2606ca8c6e-0_2.jpeg", rarity: "c" },
        { file: "c1a5b469-0ba6-4027-905a-ba2606ca8c6e-0_3.jpeg", rarity: "c" },
        { file: "d7483fa9-8233-41ba-a1c9-2180d8b1e153-0_0.jpeg", rarity: "c" },
        { file: "e980a62c-d170-4665-826b-351a8a215070-0_0.jpeg", rarity: "c" },
        { file: "e980a62c-d170-4665-826b-351a8a215070-0_1.jpeg", rarity: "c" },
        { file: "e980a62c-d170-4665-826b-351a8a215070-0_2.jpeg", rarity: "c" },
        { file: "e980a62c-d170-4665-826b-351a8a215070-0_3.jpeg", rarity: "c" },
        { file: "ed526104-8494-431c-9235-5c04c473a1cf-0_2.jpeg", rarity: "c" },
        { file: "f6854414-ce56-493b-bb11-6bfa04b28fa2-0_3.jpeg", rarity: "c" },
    ],
    werewolf: [
        { file: "1aae2f16-b823-4ed7-8475-4fe043273a7c-0_0.jpeg", rarity: "c" },
        { file: "1aae2f16-b823-4ed7-8475-4fe043273a7c-0_1.jpeg", rarity: "c" },
        { file: "1aae2f16-b823-4ed7-8475-4fe043273a7c-0_2.jpeg", rarity: "c" },
        { file: "1aae2f16-b823-4ed7-8475-4fe043273a7c-0_3.jpeg", rarity: "c" },
        { file: "3927f0e7-de56-4600-ba0e-9ed591163e19-0_3.jpeg", rarity: "c" },
    ],
    yhetee: [
        { file: "59e02654-3e19-4aab-bcbb-f1630c474ac6-0_0.jpeg", rarity: "c" },
        { file: "59e02654-3e19-4aab-bcbb-f1630c474ac6-0_3.jpeg", rarity: "c" },
        { file: "b06019f5-59e6-431f-bf42-d46d5ccbd5cd-0_0.jpeg", rarity: "c" },
        { file: "b06019f5-59e6-431f-bf42-d46d5ccbd5cd-0_2.jpeg", rarity: "c" },
    ],
};
